module.exports = __webpack_public_path__ + "static/media/toolbox.2f2d9ee6.svg";